import { BASE_ROUTE } from '../base';

export const BASE_FORMS_TEMPLATES_ROUTE = `${BASE_ROUTE}/templates`;
